module.exports = __webpack_public_path__ + "img/mile5-m@1.3003f7ab.jpg";